export const dark = {
    '--primary-color': '#2B2B2B',
    '--primary-accent-color': '#5C5C5C',
    '--primary-accent2-color': '#141414',
    '--secondary-color': '#474747',
    '--secondary-accent-color': '#999999',
    '--secondary-accent2-color': '#EBEBEB',
    '--text-color': '#F5F5F5',
    '--text-color2': '#525252',
    '--subtitle-color': '#999999',
    '--code-color': '#ff6e6e',
    '--code-background-color': '#333437',
    '--error-color': '#ff0033',
    '--pending-color': '#e9c46a',
    '--success-color': '#00E676',
    '--focus-color': '#957fef', // BBB2E9, 957fef
    '--focus-color2': '#F99FAA',
    '--category-zero-color': '#999999',
    '--category-zero-color-2': '#707070',
    '--category-zero-color-3': '#858585',
    '--category-one-color': '#ef233c',
    '--category-one-color-2': '#F14156',
    '--category-one-color-3': '#F57A89',
    '--category-two-color': '#ffba08',
    '--category-two-color-2': '#FFCB47',
    '--category-two-color-3': '#FFDC85',
    '--category-three-color': '#5e60ce',
    '--category-three-color-2': '#7374D4',
    '--category-three-color-3': '#B1B2E7',
    '--brightness': 1.2,
    '--icon-color': '#F5F5F5',
    '--highlight-color': '#ffdd00',
}
// F6F6F9 , #FFFFFF
// Original: --primary-color => F4F4F5, --secondary-color => E0E0E0

export const light = {
    '--primary-color': '#FFF',
    '--primary-accent-color': '#EAEAEC',
    '--primary-accent2-color': '#B8B8B8',
    '--secondary-color': '#f9f8f8',
    '--secondary-accent-color': '#676767',
    '--secondary-accent2-color': '#A3A3A3',
    '--text-color': '#1e1f21',
    '--text-color2': '#E3E2DE',
    '--subtitle-color': '#E3E2DE',
    '--code-color': '#DD4124',
    '--error-color': '#ff0033',
    '--pending-color': '#e9c46a',
    '--success-color': '#00E676',
    '--focus-color': '#957fef',
    '--focus-color2': '#BBB2E9',
    '--category-one-color': '#ef233c',
    '--category-two-color': '#ffba08',
    '--category-three-color': '#5e60ce',
    '--category-one-color-2': 'red',
    '--category-two-color-2': 'red',
    '--category-three-color-2': 'red',
    '--brightness': 0.95,
    '--icon-color': '#19171199',
    '--highlight-color': '#ffdd00',
}

export const base = {
    '--icon-size': '0.8rem',
    '--check-size': '0.8rem',
    '--popout-small-width': '10rem',
    '--popout-width': '15rem',
    '--popout-large-width': '25rem',
    '--popout-font-size': '0.9rem',
    '--main-padding-width': '30%',
    '--main-padding-width-small': '10%',// was 10% initially
    '--main-padding-width-smaller': '2.5%',
    '--font-family': 'Helvetica Neue, Arial, sans-serif',
    '--box-shadow': '0px 2px 1px -1px var(--primary-accent2-color),' +
                    '0px 1px 1px 0px var(--primary-accent2-color),' +
                    '0px 1px 3px 0px var(--primary-accent2-color)'
}